import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import servicesData from "./servicesData";

import UniformCard from "../../components/UniformCard/UniformCard";

const ServicesCard = (props) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1);
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          const yOffset = -100; // Account for fixed header
          const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const toggleCard = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const formatSlug = (text) => {
    if (!text) return "";
    return text
      .replace(/&/g, "And")
      .replace(/-/g, " ")
      .replace(/[^a-zA-Z0-9 ]/g, "")
      .split(" ")
      .map((word, i) =>
        i === 0
          ? word.toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join("");
  };

  const businessSetupServices = servicesData.filter(
    (s) =>
      s.category === "Business Setup & Compliance" ||
      s.category === "Corporate Secretarial & Governance"
  );
  const advisoryDealsServices = servicesData.filter(
    (s) =>
      s.category === "Advisory & Deals" ||
      s.category === "IPO Advisory & Capital Markets Readiness" ||
      s.category === "Management Consulting & Business Transformation" ||
      s.category === "ESG & Sustainability Consulting"
  );

  const renderServiceCards = (services) => {
    return services.map((service) => (
      <div className="col-12 col-md-6 col-lg-4" key={service.Id}>
        <Link
          to={`/service-category/${formatSlug(service.sTitle)}`}
          onClick={ClickHandler}
          style={{ textDecoration: "none" }}
        >
          <UniformCard
            image={service.image}
            title={service.sTitle}
            imageFit="contain"
            aspectRatio="16/10"
            imagePadding="20px"
            centered={false}
            sx={{
              cursor: "pointer",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              "& .card-image-hover": {
                transition: "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
              },
              "&:hover": {
                transform: "translateY(-10px)",
                borderColor: "var(--primary-color)",
                boxShadow: "0 20px 40px rgba(var(--primary-color-rgb), 0.15)",
              },
            }}
          >
            <Box sx={{ mt: "auto", pt: 2 }}>
              <Typography
                sx={{
                  color: "var(--primary-color)",
                  fontWeight: 600,
                  fontSize: "0.95rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                View Details
                <i
                  className="fa fa-arrow-right"
                  style={{ fontSize: "0.8rem" }}
                ></i>
              </Typography>
            </Box>
          </UniformCard>
        </Link>
      </div>
    ));
  };

  return (
    <section className={`service-section-s2 pb-5 ${props.sClass}`}>
      <div className="container">
        {/* Business Setup & Compliance Support Section */}
        <div id="business-setup" className="category-section mb-5">
          <div className="category-header text-center mb-5">
            <Link
              to="/service-group/business-setup-compliance"
              onClick={ClickHandler}
              style={{ textDecoration: "none" }}
            >
              <h2
                className="category-title"
                style={{
                  fontSize: "2.75rem",
                  fontWeight: "800",
                  color: "var(--primary-color)",
                  marginBottom: "1.2rem",
                  cursor: "pointer",
                }}
              >
                Business setup, Assurance & Compliance Support
              </h2>
            </Link>
            <Box
              sx={{
                width: "80px",
                height: "4px",
                background: "var(--primary-color)",
                margin: "0 auto 20px",
              }}
            />
            <p
              className="category-description"
              style={{
                fontSize: "1.1rem",
                color: "#687693",
                maxWidth: "800px",
                margin: "0 auto",
              }}
            >
              We help global businesses for building a successful business
              presence in India
            </p>
          </div>
          <div className="row g-4">
            {renderServiceCards(businessSetupServices)}
          </div>
        </div>

        {/* Advisory & Deals Section */}
        <div id="advisory-deals" className="category-section mt-5 pt-5">
          <div className="category-header text-center mb-5">
            <Link
              to="/service-group/advisory-deals"
              onClick={ClickHandler}
              style={{ textDecoration: "none" }}
            >
              <h2
                className="category-title"
                style={{
                  fontSize: "2.75rem",
                  fontWeight: "800",
                  color: "var(--primary-color)",
                  marginBottom: "1.2rem",
                  cursor: "pointer",
                }}
              >
                Advisory & Deals
              </h2>
            </Link>
            <Box
              sx={{
                width: "80px",
                height: "4px",
                background: "var(--primary-color)",
                margin: "0 auto 20px",
              }}
            />
            <p
              className="category-description"
              style={{
                fontSize: "1.1rem",
                color: "#687693",
                maxWidth: "800px",
                margin: "0 auto",
              }}
            >
              Strategic advisory services for growth, transactions, and
              sustainable business development
            </p>
          </div>
          <div className="row g-4">
            {renderServiceCards(advisoryDealsServices)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesCard;
